module.exports = __webpack_public_path__ + "static/media/SDFSA_3-634w.0dc0055d.jpg";